<template>
    <div>
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol"  :rules="rules">
            <!-- <div class="item-line">经销商信息</div> -->
            <a-row class="flex-row">
                
               
                <a-col :span="12">
                    <a-form-model-item label="主推品系" class="strainClass"  prop="strainsNameList">
                        <!-- <a-select v-model="form.strainsName" multiple>
                            <a-select-option key="0" label="全部" value="0" />
                            <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode" :label="item.strains" :value="item.strainsCode" />
                        </a-select> -->
                      <div style="display: flex; flex-direction: column; gap: 4px;width: 100%">
                        <a-select v-model="form.strainsNameList" mode="multiple" placeholder="请选择品系" :collapse-tags="true" @change="onStrainsChange" :disabled="isDisabled()">
                          <!-- <a-select-option  value="0" >全部</a-select-option> -->
                          <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode"  :value="item.strains" >{{item.strains}}</a-select-option>
                        </a-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.4;">
                          注意：公路用车与工程用车不可同时选择
                        </div>
                      </div>
                      <a-tooltip v-if="strFalse" style="margin-left: 5px;">
                          <template #title>选择主推品系会删除已选择的主推车型及数量，请谨慎操作</template>
                          <a-icon type="info-circle"></a-icon>
                      </a-tooltip>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6" style="display: none">
                    <a-form-model-item label="主推车型及数量" prop="strainsCarName" :label-col="{span:9}">
                        <a-select
                            ref="selectCarSeriesPopup"
                            v-model="form.strainsCarName"
                            placeholder="主推车型及数量"
                            class="proxySelect"
                            :visible-change="false"
                            @click.native="onShowCarSeries"
                            :disabled="isDisabled()"
                        />
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="6">
                    <a-form-model-item label="计划时间" prop="planTime">
                        <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.planTime" class="date-picker"/>
                    </a-form-model-item>
                </a-col> -->

              <a-col :span="12">
                <a-form-model-item label="地点" prop="activityPlace" >
                  <a-cascader
                      v-model="form.activityPlace"
                      :options="regionOptions"
                      :fieldNames="{ label: 'areaName', value: 'areaName', children: 'children' }"
                      placeholder="请选择地点"
                      allowClear
                      :disabled="isDisabled()"
                  />
                </a-form-model-item>
              </a-col>
                <a-col :span="12">
                    <a-form-model-item label="详细地址" >
                        <a-input v-model="form.addressInfo" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="预计参与人数">
                        <a-input-number :min="0" v-model="form.peopleNum" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="6">
                    <a-form-model-item label="是否二网活动" prop="isSecondaryNetwork">
                        <a-radio-group v-model="form.isSecondaryNetwork" :disabled="isDisabled()" >
                            <a-radio :value="1">
                                是
                            </a-radio>
                            <a-radio :value="2">
                                否
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col> -->
                <a-col :span="6">
                    <a-form-model-item label="是否二网活动" prop="isSecondaryNetwork" style="display: flex; align-items: center;">
                      <a-radio-group v-model="form.isSecondaryNetwork" :disabled="isDisabled()" style="display: flex; gap: 16px;">
                        <a-radio :value="1">是</a-radio>
                        <a-radio :value="2">否</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
         
                <a-col :span="6" >
                    <a-form-model-item label="二网名称" prop="secondaryNetworkName" :rules="[{ required: form.isSecondaryNetwork === 1, message: '请输入二网名称', trigger: 'blur' }]">
                        <a-input v-model="form.secondaryNetworkName" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
            <!-- <div class="item-line">负责人信息</div> -->
                <a-col :span="6">
                    <a-form-model-item label="负责人姓名" prop="headName">
                        <a-input v-model="form.headName" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="负责人电话" prop="headPhone">
                        <a-input v-model="form.headPhone" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <!-- <a-row> -->
                    <a-col :span="24">
                        <a-form-model-item label="备注" >
                            <a-textarea :auto-size="{ minRows: 2, maxRows: 6 }" v-model="form.remark" :disabled="isDisabled()"/>
                        </a-form-model-item>
                    </a-col>
                <!-- </a-row> -->
            <!-- <div class="item-line">费用预算</div> -->
            <div class="item-line">费用信息</div>
                <a-col :span="6">
                    <a-form-model-item label="会务费">
                        <a-input-number :min="0" v-model="form.conferenceFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="油费">
                        <a-input-number :min="0" v-model="form.fuelCost" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="过路费">
                        <a-input-number :min="0" v-model="form.toll" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="礼品费">
                        <a-input-number :min="0" v-model="form.giftFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="布展费">
                        <a-input-number :min="0" v-model="form.moveInFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="其他">
                        <a-input-number :min="0" v-model="form.otherFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="合计">
                        <a-input-number :min="0" v-model="form.totalCost" disabled/>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <!-- 审批人可见 -->
            <a-row v-if="approveBtnDisplay === true">
            <!-- <a-row> -->
                <a-col :span="6">
                    <a-form-model-item label="经销商已补差">
                        <!-- <a-input v-model="form.dealerDiff"  :disabled="isDisabled()"/> -->
                        <a-input v-model="form.dealerDiff" disabled/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="区域已补差">
                        <!-- <a-input v-model="form.areaDiff"  :disabled="isDisabled()"/> -->
                        <a-input v-model="form.areaDiff" disabled/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="最高支持费用">
                        <a-input v-model="form.maxSupportFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
            </a-row>      
        </a-form-model>
        <div class="item-line">主推车型及数量</div>
        <div style="padding: 5px 1%" v-if="!isDisabled()">
            <vxe-button status="primary" @click="onShowCarSeries">新增</vxe-button>
            <vxe-button status="warning" @click="deleteOjb">删除</vxe-button>
        </div>
        <div class="filter-container" style="padding: 0px 1%">
            <vxe-table
                ref="xTable"
                border
                show-header-overflow
                show-overflow
                class="mytable-scrollbar"
                :column-config="{ resizable: true }"
                stripe
                round
                style="margin-top: 10px"
                :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
                :scroll-y="{ enabled: false }"
                :row-config="{ isHover: true }"
                :data="vehicleModelAndQuantity"
                @checkbox-change="selectionChange"
                @checkbox-all="selectionChange"
            >
                <vxe-column type="checkbox" width="60" align="center" />
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column title="车型名称" field="vCode" align="center" />
                <vxe-column title="数量" field="quantity" align="center" />
            </vxe-table>
        </div>
        <a-modal title="选择车型" :visible.sync="showCarSeries" width="800px" @cancel="showCarSeries=false" class="car-modal">
            <div style="display: flex">
                <div>
                    <a-input v-model="planCodeOrName" placeholder="输入车型" clearable style="width: 200px; margin-right: 1rem" @keyup.enter.native="carPageData(1)" />
                </div>
                <div>
                    <a-select v-model="showCarStrainsNameSelected" mode="multiple" placeholder="选择品系" clearable style="width: 300px; margin-right: 1rem" >
                      <a-select-option v-for="item in showCarCarStrainsDS" :key="item.strainsCode"  :value="item.strains" >{{item.strains}}</a-select-option>
                    </a-select>
                </div>
                <div>
                    <vxe-button status="primary"  class="filter-search-item" @click="carPageData(1)">搜索</vxe-button>
                    <vxe-button  class="filter-search-item" @click="resetForm()">重置</vxe-button>
                </div>
            </div>
            <vxe-table
              ref="xTable"
              :loading="listLoading"
              border
              class="mytable-scrollbar"
              show-header-overflow
              show-overflow
              :column-config="{ resizable: true }"
              stripe
              round
              style="margin-top: 10px"
              :max-height="$store.state.app.height - 350 < 185 ? 340 : $store.state.app.height - 350"
              :scroll-y="{ enabled: false }"
              :row-config="{ isHover: true }"
              :checkbox-config="{checkRowKeys: defaultSelecteRows}"
              :data="carList"
            >
              <vxe-column type="checkbox" width="60" align="center" />
              <vxe-column type="seq" title="序号" width="60" align="center" />
              <vxe-column field="vCode" title="车型" align="center" width="310">
              </vxe-column>
              <vxe-column field="quantity" title="车型数量" align="center" width="305">
                <template #default="{ row }">
                    <a-input-number :min="0" v-model="row.quantity"/>
                  </template>
              </vxe-column>
            </vxe-table>
            <vxe-pager
                style="margin: 10px 0 -10px 0"
                v-show="!listLoading"
                :current-page="pagination.current"
                :page-size="pagination.size"
                :total="pagination.total"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                @page-change="changePage"
            />
            <span slot="footer" class="dialog-footer">
              <vxe-button @click="showCarSeries = false">取 消</vxe-button>
              <vxe-button status="primary" @click="onSeriesConfirm">确 定</vxe-button>
            </span>
          </a-modal>
    </div>


</template>

<script>
import { loadAreaTreeCasData } from '@/services/baseCodeSource';
import { queryCarStrainsInfo, getCarTypeList, getCarTypeDeleteList, getApproveWriteOffCost } from '@/api/activity.js'  //

export default {
    props:['formData', 'activity', 'formType', 'approveBtnType', 'priceDiff'],
    data() {
    return {
      labelCol: { span: 8, style: { width: '100px' } },
      wrapperCol: { span: 14 },
      strainsCarName: '', //主推车型及数量
      form: {
        // address: [], // 区域
        dealerName: '', // 经销商
        threeLevelName: '', // 活动类型
        strainsNameList: [], // 主推品系
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        vehicleModelList: [],  //主推车型及数量  修改
        planTime: '',  // 计划时间
        activityPlace: [], // 地点
        showRoute: '',  // 展示路线   表单2类型
        addressInfo:'', // 详细地址
        peopleNum: '', // 预计参与人数
        isSecondaryNetwork: 1, // 是否二网活动 1 是 2 否
        secondaryNetworkName: '', // 二网活动名称
        headName: '', // 负责人名称
        headPhone: '', // 负责人电话
        conferenceFee: '', //会务费
        fuelCost: '', // 油费
        toll: '', // 过路费
        giftFee: '', // 礼品费
        moveInFee: '', // 布展费
        otherFee: '', // 其他费用
        totalCost: 0, //总计
        dealerDiff: '',
        areaDiff: '',
        maxSupportFee: '',
        remark: ''
      },
      rules: {
        // address: [
        //   { required: true, message: '请选择区域', trigger: 'change' },
        // ],
        dealerName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        threeLevelName: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        strainsNameList: [
          { required: true, message: '请选择主推品系', trigger: 'change' },
        ],
        // strainsCarName: [
        //   { required: true, message: '请选择主推车型及数量', trigger: 'change' },
        // ],
        planTime: [
          { required: true, message: '请选择计划时间', trigger: 'change' },
        ],
        activityPlace: [
          { required: true, message: '请输入地点', trigger: 'change' },
        ],
        isSecondaryNetwork: [
          { required: true, message: '', trigger: 'change' },
        ],
        headName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        headPhone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' },
        ],
      },
      regionOptions:[],
      showCarSeries: false,
      listLoading: false,
      pagination: {
        // 分页
        total: 0,
        size: 20,
        current: 1,
      },
      defaultSelecteRows: [], // 默认选中行
      vehicleModelAndQuantity: [], //已选车型
      vehicleModelCheck: 1, // 0不检验 1校验 车型代码必选
      // 车型列表
      carList: [], 
      carIds: [],
      planCodeOrName: '',
      showCarStrainsIdSelected: [],  // 选择车辆弹出界面中进行品系筛选使用
      showCarStrainsNameSelected: [],  // 选择车辆弹出界面中已选择品系
      showCarCarStrainsDS: [],  // 选择车辆弹出界面中提供的选择品系选项
      carStrainsDS: [],
      selectionVal: [],   //  选中主推车型及数量的数据
      approveBtnDisplay: false,
      strFalse: false
    };
  },
  created() {
    this.getArea()
    this.SelectListsFun()
    this.getCarStrains()
  },
  mounted() {
    // let url = "https://test-scrmxc.dflzm.com/actPlan/executePicture/list?code=TB202501130005"
    //     if (url.indexOf("com") > 0) {
    //     const accesstoken = url.split("com/")[0]
    //         console.log(accesstoken + 'com/','---accesstoken-----');
    //         console.log(url,'---url-----');
            
    // }
    if (this.formData && this.formData.id) {
        setTimeout(() => {
            this.strFalse = true
            this.getApproveWriteOffCost()
            this.carIds = this.formData.strainsCodeList
            // this.carPageData()
            // this.form  = Object.assign(this.form, {
            //     ...this.formData,
            //     activityPlace: this.formData.activityPlace.split(',')
            // })
            this.form  = Object.assign(this.form, {
                ...this.formData,
                activityPlace: this.formData.activityPlace.split(',')
            })
            console.log(this.form,'-----form--data');
            console.log(this.formData,'-----formData--data');

            if(this.carStrainsDS != null){
              this.form.strainsCodeNameMap = this.carStrainsDS
                  .filter(item => this.formData.strainsCodeList.includes(item.strainsCode))
                  .reduce((obj, item) => {
                    obj[item.strainsCode] = item.strains;
                    return obj;
                  }, {});
            }
            // this.vehicleModelAndQuantity = this.formData.vehicleModelAndQuantity
            let arrData = this.formData.vehicleModelList.map(item =>{
                return {
                    vCode: item.vehicleCode,
                    quantity: item.quantity,
                    ...item
                }
            })
            this.vehicleModelAndQuantity = arrData
            
            const list = this.vehicleModelAndQuantity.map(item => `车型名称：${item.vehicleModel} - 数量：${item.quantity}`)
            this.strainsCarName = list.join('; ')

            // if (!this.form.dealerDiff) {
            //     this.form.dealerDiff = this.priceDiff.dealerDiff
            // }
            // if (!this.form.areaDiff) {
            //     this.form.areaDiff = this.priceDiff.areaDiff
            // }

        }, 3000)
    }
  },

  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    async getArea() {
      this.regionOptions = await loadAreaTreeCasData();
    },
    onShowCarSeries() {
      // 检查表单中是否选择了主推品系（strainsNameList为空）
      if (this.form.strainsNameList.length <= 0) {
          this.$message.error('请先选择主推品系')
          return
      }else {
          // 检查formData是否存在并且有id字段
          if (this.formData && this.formData.id) {
              // 如果满足条件，调用carPageData方法获取数据
              this.carPageData()
          }
      }

      // 进入车型选择页面的品系选项，只有主页面选的品系才能选
      this.showCarCarStrainsDS = this.carStrainsDS.filter(value => this.form.strainsNameList.includes(value.strains))

        // 让selectCarSeriesPopup组件失去焦点
      this.$refs.selectCarSeriesPopup.blur()
    //   设置showCarSeries为true，显示车系列表
      this.showCarSeries = true
    //   在DOM更新后执行回调
      this.$nextTick(() => {
        // 检查是否没有选择车系名称 如果没有选择车系名称，清空表格中的复选框选择
        if (!this.strainsCarName) {
            this.$refs.xTable.clearCheckboxRow()
        }
      })
    },
    // 获取选中的主推车型及数量
    selectionChange(val) {
      this.selectionVal = val.records
      console.log(val,this.vehicleModelAndQuantity,'---vall----');
      
    },
    //  删除
    deleteOjb() {
      if (this.selectionVal.length > 0) {
        this.$confirm({
          title: '即将删除选择的数据, 是否继续?',
          content: '',
          onOk:() => {
            // 过滤数据，留下未勾选的数据
            this.vehicleModelAndQuantity = this.vehicleModelAndQuantity.filter(val => !this.selectionVal.some(va => va.vCode === val.vCode))
            const list = this.vehicleModelAndQuantity.map(item => `车型名称：${item.vehicleModel} - 数量：${item.quantity}`)
            this.strainsCarName = list.join('; ')
            console.log(this.form,this.vehicleModelAndQuantity,'---this.form.strainsCarName删除的---');
            // this.$message.success('删除成功！')

            // 切换选项 删除 全部
            if(this.strFalse == true){
                // this.vehicleModelAndQuantity
                let arrId = this.selectionVal.map(item =>{
                    return item.id
                })
                getCarTypeDeleteList(arrId).then(res => {
                    if (res.code === 1) {
                        this.$message.success(res.message)
                        this.selectionVal = [] //  选中的数据清空
                    }
                })
            }
          },
          onCancel() {}
        });
      } else {
        this.$message.error('请选择要删除的数据')
      }
    },
    onSeriesConfirm() {
        // this.vehicleModelAndQuantity = this.$refs.xTable.getCheckboxRecords();
        let vehicleModelAndQuantity = this.$refs.xTable.getCheckboxRecords();
        console.log("🚀 ~ onSeriesConfirm ~ this.vehicleModelAndQuantity:", this.vehicleModelAndQuantity)
        if (!vehicleModelAndQuantity.length) {
           return  this.$message.error('请选择车型')
        }
        // 检查是否有车型没有填写数量
        if (vehicleModelAndQuantity.some(item => item.quantity == null)) {
            return  this.$message.error('请输入已选车型的数量')
        }
        // 筛选出已存在的车型（防止重复添加）
        const newArr = vehicleModelAndQuantity.filter(item => this.vehicleModelAndQuantity.some(existingItem => existingItem.vCode === item.vCode));
        if (newArr.length > 0) {
            return  this.$message.error('请勿重复添加车型')
        }
        // 筛选出新选择的车型（过滤掉已存在的） 将新选择的车型合并到已有车型列表中
        const newItems = vehicleModelAndQuantity.filter(
        item => !this.vehicleModelAndQuantity.some(existingItem => existingItem.vCode === item.vCode));
        this.vehicleModelAndQuantity = [...this.vehicleModelAndQuantity, ...newItems];
        // 隐藏车系列表弹窗
        this.showCarSeries = false
        // 将车型信息格式化为字符串数组
        const list = this.vehicleModelAndQuantity.map(item => `车型名称：${item.vCode} - 数量：${item.quantity}`)
        this.strainsCarName = list.join('; ')
        // console.log("🚀 ~ onSeriesConfirm11111 ~ this.vehicleModelAndQuantity:", this.vehicleModelAndQuantity)
    },
    gettotalCost() {
        this.form.totalCost = Number(this.form.conferenceFee) + Number(this.form.fuelCost) 
        + Number(this.form.toll) + Number(this.form.giftFee) + Number(this.form.moveInFee) + Number(this.form.otherFee)
    },
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
          this.filteredStrains()
        }
      })
    },
    getApproveWriteOffCost() {
        getApproveWriteOffCost(this.formData.id).then(res => {
            if (res.code === 1) {
                this.form.dealerDiff = res.data.dealerApproveWriteOffCost
                this.form.areaDiff = res.data.regionApproveWriteOffCost
                this.approveBtnDisplay = res.data.display
            }
        })
    },
    // 过滤品系
    filteredStrains() {
      if (this.activity.strainsCarCode) {
        const stringArray = this.activity.strainsCarCode.split(',')
        const arr = []
        stringArray.forEach(item => {
          const itemArr = item.split('-')
          arr.push(itemArr[0])
        })
        this.carStrainsDS = this.carStrainsDS.filter(value => arr.includes(value.strainsCode))
      }
    },
    onStrainsChange (e) {
        // this.carIds = this.carStrainsDS.find(item => item.strains === e).strainsCode
      this.carIds = this.carStrainsDS
          .filter(item => e.includes(item.strains))
          .map(item => item.strainsCode);

      this.form.strainsCodeList = this.carIds  //新增入参  主推品系code
      this.form.strainsCodeNameMap = this.carStrainsDS
          .filter(item => e.includes(item.strains))
          .reduce((obj, item) => {
            obj[item.strainsCode] = item.strains;
            return obj;
          }, {});
      this.carPageData()

      // 切换选项 删除 全部
      if(this.strFalse == true){
          // this.vehicleModelAndQuantity
          let arrId = this.vehicleModelAndQuantity.map(item =>{
              return item.id
          })
          getCarTypeDeleteList(arrId).then(res => {
              if (res.code === 1) {
                  this.$message.success(res.message)
                  this.vehicleModelAndQuantity = []
              }
          })
      }else {
          this.vehicleModelAndQuantity = []
      }
    },

    async carPageData(e) {
        if (e) this.pagination.current = e

        // 通过选择的品系名称获取选择品系的代码，方便传回后端进行查询
        this.showCarStrainsIdSelected = this.showCarCarStrainsDS
                                          .filter(item => this.showCarStrainsNameSelected.includes(item.strains))
                                          .map(item => item.strainsCode);

        let params = {
            strainIds: this.carIds,
            code: this.planCodeOrName,
            selectedStrainsId: this.showCarStrainsIdSelected,
            page: this.pagination.current,
            limit: this.pagination.size,
        }
        // selectedStrainsId 是在已有选择的车型上再次进行筛选
        // 调用getCarTypeList接口，传入参数，等待返回结
        const res = await getCarTypeList(params)
        
        this.pagination.total = res.data.total
        // 对返回的列表数据进行map操作
        this.carList = res.data.list.map(item => {
           return {
            // 将原item赋值给vCode属性
            vCode: item,
            // 添加quantity属性，初始值为null
            quantity: null,
            // 使用扩展运算符将原item的所有属性展开
            ...item
           }
        })
    },
    
    // 重置筛选
    resetForm() {
      this.planCodeOrName = ''
      this.showCarStrainsNameSelected = []
      this.showCarStrainsIdSelected = []
      this.carPageData()
    },
    
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
      this.carPageData()
    },

    getActivityForm() {
      const processedForm = {
        ...this.form,
        conferenceFee: this.form.conferenceFee ?? 0,
        fuelCost: this.form.fuelCost ?? 0,
        toll: this.form.toll ?? 0,
        giftFee: this.form.giftFee ?? 0,
        moveInFee: this.form.moveInFee ?? 0,
        otherFee: this.form.otherFee ?? 0,
        totalCost: this.form.totalCost ?? 0
      };

      const obj = Object.assign(processedForm, {
        dealerName: this.activity.dealerName,
        threeLevelName: this.activity.threeLevelName,
        vehicleModelList: this.vehicleModelAndQuantity.map(item => {
            return {
                vehicleCode: item.vCode,
                quantity: item.quantity,
                id: item.id ? item.id : null
            }
        }),
        //activityPlace: this.form.activityPlace ?
        //    (Array.isArray(this.form.activityPlace) ?
        //        this.form.activityPlace.join(',') :
        //        this.form.activityPlace) :
        //    ''
        activityPlace: this.form.activityPlace.join(',')
    })
    return obj
},

    // getActivityForm() {
    //     const obj = Object.assign(this.form, {
    //         dealerName: this.activity.dealerName,
    //         threeLevelName: this.activity.threeLevelName,
    //         vehicleModelList: this.vehicleModelAndQuantity.map(item => {
    //             return {
    //                 vehicleCode: item.vCode,
    //                 quantity: item.quantity,
    //                 id: item.id ? item.id : null
    //             }
    //         }),
    //         activityPlace: this.form.activityPlace.join(',')
    //     })
    //     return obj
    // },
    isDisabled() {
        // console.log("🚀 ~ isDisabled ~ this.formType:", this.formType)
        return this.formType === 'detail'
    }
  }
}
</script>

<style lang="less" scoped>
.item-line {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .ant-form {
    padding-right: 0;
  }
  /deep/ .ant-form-explain {
    font-size: 12px;
  }
  .strainClass{
    /deep/ .ant-form-item-children{
        display: flex;
        align-items: center;
        justify-content: center;
    }
  }
  .right-align {
    margin-right: 150px
}
</style>
